import React from 'react'
import { Switch, Route } from 'react-router-dom'
import IndexPage from './pages/index'
import Architecture from './pages/architecture'
import Craft from './pages/craft'
import Height from './pages/height'
import History from './pages/history'
import Journey from './pages/journey'
import Story from './pages/story'

let pages = [
  {
    path: '/',
    exact: true,
    component: IndexPage
  },
  {
    path: '/architecture',
    exact: true,
    component: Architecture
  },
  {
    path: '/craft',
    exact: true,
    component: Craft
  },
  {
    path: '/perception',
    exact: true,
    component: Height
  },
  {
    path: '/history',
    exact: true,
    component: History
  },
  {
    path: '/journey',
    exact: true,
    component: Journey
  },
  {
    path: '/story',
    exact: true,
    component: Story
  }, {
    path: '/:index',
    exact: true,
    component: IndexPage
  }
]

export default (
  <Switch>
    {pages.map((route, i) => (
      <Route
        exact
        key={'route' + i}
        path={route.path}
        render={props => (
          <route.component key={i} {...props} />
        )}
      />
    ))}
  </Switch>
)



// WEBPACK FOOTER //
// ./src/routes.js